import { OrganizationalRole, VenueUserRole } from "@/types";

export const ORGANIZATIONAL_ROLE_OPTIONS = [
  { value: OrganizationalRole.SALES, label: "Sales" },
  { value: OrganizationalRole.MARKETING, label: "Marketing" },
];

/**
 * A venue admin spans the venue, so choosing Admin selects both — a default,
 * not a lock: the field stays editable. A Member is given neither and has to
 * be placed deliberately. Same rule as the venue app's team member panel — the
 * surfaces must not drift.
 */
export const organizationalRolesForVenueRole = (role: VenueUserRole) =>
  role === VenueUserRole.ADMIN
    ? [OrganizationalRole.SALES, OrganizationalRole.MARKETING]
    : [];
